import React, { useState } from 'react'
import { TextField, IconButton, InputAdornment, Button, TextFieldProps } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'

function PasswordField({
    label = 'Lösenord',
    register,
    error,
    helperText,
    showGeneratePassword = false,
    ...props
}: TextFieldProps & {
    label?: string
    register: TextFieldProps
    error?: Error | string | boolean
    helperText: TextFieldProps['helperText']
    onChange: (event: { target: { value: string } }) => void
    showGeneratePassword?: boolean
}) {
    const [showPassword, setShowPassword] = useState(false)

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    const generateRandomPassword = () => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        let password = ''
        let hasUpperCase = false
        let hasLowerCase = false
        let hasDigit = false

        while (password.length < 15 || !hasUpperCase || !hasLowerCase || !hasDigit) {
            const char = chars[Math.floor(Math.random() * chars.length)]
            password += char
            if (/[A-Z]/.test(char)) hasUpperCase = true
            if (/[a-z]/.test(char)) hasLowerCase = true
            if (/\d/.test(char)) hasDigit = true
        }

        return password
    }

    return (
        <TextField
            margin='dense'
            label={label}
            type={showPassword ? 'text' : 'password'}
            fullWidth
            {...register}
            error={!!error}
            helperText={helperText}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position='end'>
                            <IconButton onClick={togglePasswordVisibility}>
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                            {showGeneratePassword && (
                                <Button
                                    onClick={() => {
                                        const generatedPassword = generateRandomPassword()
                                        if (props.onChange) props.onChange({ target: { value: generatedPassword } })
                                    }}
                                    size='small'
                                    sx={{ ml: 1 }}
                                >
                                    ***
                                </Button>
                            )}
                        </InputAdornment>
                    ),
                },
            }}
            {...props}
        />
    )
}

export default PasswordField
